<template>
  <ReportTableWithHeader
    :loading="isLoading"
    :downloading="isDownloading"
    :rows="rows"
    :columns="columns"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    downloadable
    :type="reportType"
    :form="form"
    @onFilter="onFilter"
    @onPageChange="onPageChange"
    @onPerPageChange="onPerPageChange"
    @onDownload="onDownload"
  />
</template>

<script>
import reportTableMixin from '@/mixins/reportTableMixin';

export default {
  mixins: [reportTableMixin],

  data() {
    return {
      columns: [
        { field: 'loan.account' },
        { field: 'loan.userName' },
        { field: 'loan.userRegister' },
        { field: 'loan.borrower' },
        { field: 'extendedDate' },
        { field: 'extendedRateAmount' },
        { field: 'extendedExtensionFee' },
        { field: 'extendedIncreaseRateAmount' },
        { field: 'extendedLoanAmount' },
        { field: 'extendedTotalAmount' },
        { field: 'currency' },
        { field: 'category' },
        { field: 'segment' },
        { field: 'areasOfActivity' },
      ],
      reportType: 'extended',
    };
  },

  methods: {
    updateFilters(data) {
      data.filters[`filter[status]`] = 'EXTENDED';
      data.filters[`filter[reportType]`] = this.reportType;
    },
  },
};
</script>
